import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import React, { useEffect, useRef } from "react";

const MenuDialog = ({ children, title, onClick = () => {} }) => {
    const dialog = useRef(null);
    const [opened, { open, close }] = useDisclosure(false);

    useEffect(() => {
        const currentDialog = dialog.current;
        const handleClickOutside = (e) => {
            if (!currentDialog) {
                return;
            }
            const rect = currentDialog.getBoundingClientRect();
            if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
                currentDialog.close();
            }
        };
        currentDialog?.addEventListener("click", handleClickOutside);
        return () => {
            currentDialog?.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <>
            <Button
                lts=".06rem"
                size="lg"
                variant="outline"
                color="gray"
                radius="md"
                onClick={() => {
                    onClick();
                    open();
                }}>
                {title}
            </Button>
            <Modal opened={opened} centered lockScroll={false} onClose={close} size="lg" radius="md" title={title}>
                {children}
            </Modal>
        </>
    );
};

export default MenuDialog;
